module.exports = require("npm:tween.js@16.3.1/src/Tween.js");